import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSuitcaseSticker: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSuitcaseSticker"><Path d="M21.5 20.5V6.5H2.5V20.5H21.5Z" stroke="currentColor"/><Path d="M15.9982 17.0004C17.3789 17.0004 18.4982 15.8811 18.4982 14.5004L15.9982 12.0004C14.6174 12.0004 13.4982 13.1197 13.4982 14.5004C13.4982 15.8811 14.6174 17.0004 15.9982 17.0004Z" stroke="currentColor"/><Path d="M5.06641 11.84L9.93127 10.0693L10.9981 13.0004L6.13323 14.7711L5.06641 11.84Z" stroke="currentColor"/><Path d="M7.5 6.5V2.5H16.5V6.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconSuitcaseSticker;
